import { UserLoggedInNavigatorNavigationProp } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";

export type StoreAdminNavigationParamList = {
  TeamsAdmin: object;
  TopicsAdmin: object;
  DashboardsAdmin: object;
  CalendarsAdmin: undefined;
  ArchivedTeams: object;
  ArchivedCalendars: undefined;
  StoreAdminMain: object;
  StoreEditName: object;
  ScreenList: object;
  ScreenAdmin: {
    screen: {
      id: string;
      name: string | null;
    };
  };
  ScreenAdminEditName: {
    screenId: string;
  };
  ScreenAdminSelectDashboard: {
    screenId: string;
    currentDashboardId?: string;
  };
  AddScreen: {
    userCode?: string;
    fromStorecast?: {
      id: string;
      name: string;
    };
  };
  AddScreenScanQR: {
    userCode?: string;
    fromStorecast?: {
      id: string;
      name: string;
    };
  };
  AddScreenSetName: {
    screenId: string;
    fromStorecast?: {
      id: string;
      name: string;
    };
  };
  AddScreenInfo: {
    screenId: string;
    fromStorecast?: {
      id: string;
      name: string;
    };
  };
  AddScreenAssignDashboardPrompt: {
    screenId: string;
    screenName: string;
  };
  AddScreenAssignDashboard: {
    screenId: string;
    screenName: string;
    fromStorecast?: {
      id: string;
      name: string;
    };
  };
  AddScreenSuccess: {
    fromStorecast?: {
      id: string;
      name: string;
    };
    screenName: string;
    dashboardName: string;
    dashboardId: string;
  };
  AddOrEditScheduleItem: {
    screen: {
      id: string;
      name: string | null;
    };
    scheduleId?: string;
  };
  KPIAdmin: {
    standalone?: boolean;
  };
  UserAdmin: {
    storeId?: string;
  };
  IntegrationAdmin: object;
  ConnectAdmin: object;
  ConnectAdminCreateInit: undefined;
  ConnectAdminPreview: { url: string };

  ConnectAdminInbox: {
    inboxId: string;
  };
  ConnectAdminSiteAdmin: undefined;
  TeamScheduleAdminSelectTeam: object;
  SuperAdminPanel: {
    storeId: string;
  };
  TodoCategoryAdminList: {
    standalone?: boolean;
  };
  TodoCategoryCreate: object;
  TodoCategoryEdit: {
    id: string;
  };
  TodoCategoryEditGeneral: {
    id: string;
  };
  TodoCategoryTagCreate: {
    categoryId: string;
  };
  TodoCategoryTagEdit: {
    tag: {
      id: string;
      title: string;
      color: string;
    };
    categoryId: string;
  };
  IntegrationFlyerCreate: object;
  IntegrationFlyer: {
    id: string;
    title: string | null;
    lastError: string | null;
    lastCheckedAt: string | null;
    status: "failed" | "pending" | "success" | null;
    type?: "flyer" | "pollFile";
  };
  IntegrationTurnpikeCreate: object;
  IntegrationTomra: object;
  IntegrationTomraTeams: object;
  IntegrationTomraRvms: object;
  IntegrationTomraCreate: object;
  IntegrationNewsfeed: object & { newsfeedId: string };
  IntegrationWebFetcherCreate: object;
  IntegrationWebFetcher: object;
  Integration: {
    type: "flourish" | "bokaklipp" | "pushappy";
    mode: "create" | "edit";
  };
  IntegrationTilTidCreate: object;
  IntegrationSoftOneCreate: object;
  IntegrationSoftOneOrgCreate: object;
  IntegrationQuinyxCreate: object;
  IntegrationInvafreshCreate: object;
  IntegrationNewsfeedCreate: object;
  IntegrationICAScreen: object;
  ServiceAccounts: object;
  ServiceAccountCreate: object;
};

export type StoreAdminNavigationProp<
  T extends keyof StoreAdminNavigationParamList,
> = CompositeNavigationProp<
  UserLoggedInNavigatorNavigationProp<"StoreAdmin">,
  NativeStackNavigationProp<StoreAdminNavigationParamList, T>
>;

export type StoreAdminRouteProps<
  T extends keyof StoreAdminNavigationParamList,
> = RouteProp<StoreAdminNavigationParamList, T>;

export type StoreAdminNavigationScreenProps<
  T extends keyof StoreAdminNavigationParamList,
> = {
  route: StoreAdminRouteProps<T>;
  navigation: StoreAdminNavigationProp<T>;
};

export const StoreAdminStack =
  createNativeStackNavigator<StoreAdminNavigationParamList>();
